/*
 * @Description:
 * @Date: 2022-03-14 19:18:12
 */

import { reactive, ref, nextTick } from 'vue';
import { defineStore } from 'pinia';
import { XrkMessage } from 'xrk-components';
import { storage, sessionStorage } from '@/utils/storage';
import router from '@/router';
import qiankunStore from '@/qiankun/store'; // qiankun
import { User } from '@cTypes/user';
import { entpRnv, queryUserInfo } from '@data-source/user/apis';
import appStore from '@/store';
import { logOut, queryFunction } from '@/common/data-source/user/apis';

const name = 'useUserStoreSetup';
const useSetup = defineStore(
  name,
  () => {
    const info = reactive<User>({
      authentication: null,
      loginUserId: null, // userId
      name: null,
      phone: null,
      entpName: null,
      entpId: null, //企业id
      isSuperAdministrator: 0, // 是否是超级管理员0否 1是
      entpType: null, // 主体类型: 1:工业 2:服务商 3:供应商
      duty: null, // 用户当前职能
      duties: null, //  具有哪些职能，这个是算出来的1：向日葵功能 2：工业功能 3：服务商功能 4：供应商功能 5：监管功能 6 运营基地
      entpAuthStatus: null,
      isSkip: null,
      entAuditStatus: null,
      functionCode: null,
      isBaseAsp: null // 服务商种类 0(普通服务商)  1(运营基地服务商)  初始化进去
    });

    const updateInfo = async () => {
      const res = await queryUserInfo();
      Object.assign(info, { ...res.data, deptId: res.data.depId });
      return info;
    };

    const setInfo = payload => {
      Object.assign(info, payload);
      // qiankun: 同步到子服务中
      qiankunStore.setGlobalState(payload);
    };

    const login = async (payload: User) => {
      // 登录进来的时候要查是否需要签约合同，刷新菜单不检查
      setInfo({ ...payload, shouldShowContractSign: true });
      await initUserSystemData();
      // 跳转任意页面（包括不存在的），交给路由拦截处理
      router.replace({
        path: '/'
      });
    };
    // TODO: 退出登录需要暴漏给子应用，方便子应用在接口拦截时处理登录超时、失效
    const logout = async () => {
      await logOut();
      XrkMessage.success('您的账号已退出登录');
      clearUser();
    };
    const clearUser = (query = {}) => {
      setInfo({ authentication: null });
      nextTick(() => {
        storage.clear();
        sessionStorage.clear();
        router.replace({
          path: '/login',
          query
        });
      });
    };
    const setEntpAuthStatus = async () => {
      const { data } = await entpRnv();
      setInfo({
        entpAuthStatus: data.authStatus,
        isSkip: data.isSkip,
        entAuditStatus: data.auditStatus
      });
    };

    // 当前用户职能
    const userFunction = ref<
      Array<{
        functionCode: 1 | 2 | 3; // 职能 ： 1 工业职能 （对应菜单 gyMenuList ）      2 服务商职能 （对应菜单 csoMenuList）   3 供应商职能 （对应菜单 gysMenuList）
        functionName: string;
        defaultOrNot: 0 | 1; // 是否默认 0否 1是
      }>
    >([]);
    const defaultUserFnCode = ref<1 | 2 | 3>(null);
    const defaultUserFnName = ref<string>(null);
    const getUserFunction = async () => {
      const res = await queryFunction();
      if (res?.data?.length) {
        let defaultObj = null;
        userFunction.value = res.data;
        userFunction.value.forEach(item => {
          item.functionName = {
            1: '工业账号',
            2: '服务商账号',
            3: '供应商账号'
          }[item.functionCode];
          if (item.defaultOrNot === 1) defaultObj = item;
        });
        defaultUserFnCode.value = defaultObj?.functionCode || null;
        defaultUserFnName.value = defaultObj?.functionName || null;
      } else {
        userFunction.value = [];
        defaultUserFnCode.value = null;
        defaultUserFnName.value = null;
      }
    };

    // 登录后、APP加载调用一次
    const initUserSystemData = async (menuAfter?) => {
      if (!info.authentication) return;
      await Promise.all([
        updateInfo(),
        setEntpAuthStatus(),
        appStore.useMenuStoreSetup.setMenus({
          menuAfter
        })
      ]);
    };

    return {
      info,
      setInfo,
      updateInfo,
      login,
      logout,
      clearUser,
      setEntpAuthStatus,
      initUserSystemData,
      userFunction,
      defaultUserFnCode,
      defaultUserFnName,
      getUserFunction
    };
  },
  {
    persist: true
  }
);

export { useSetup, name };
